<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Input/NewDInputPreview'
export default {
  name: 'NewDPhonePreview',
  extends: compoment
}
</script>
